import { render, staticRenderFns } from "./released_2.vue?vue&type=template&id=ea45414a&scoped=true"
import script from "./released_2.vue?vue&type=script&lang=js"
export * from "./released_2.vue?vue&type=script&lang=js"
import style0 from "./released_2.vue?vue&type=style&index=0&id=ea45414a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea45414a",
  null
  
)

export default component.exports